const memory = new Map<string,string>();

export function getStorage(type:'local'|'session') {
  try {
    if (typeof window !== 'undefined') {
      return type === 'local' ? window.localStorage : window.sessionStorage;
    }
  } catch {}

  return memory;
}